export const EN_TO_FR = {
  "/": "/fr",
  "/everything-we-sell": "/fr/tout-ce-que-nous-vendons",
  "/book-a-meeting": "/fr/prendre-rendez-vous",
  "/book-appointment/thank-you": "/fr/rendez-vous/merci",
  "/life-insurance": "/fr/assurance-vie",
  "/life-insurance-brampton": "/fr/assurance-vie-brampton",
  "/life-insurance-toronto": "/fr/assurance-vie-toronto",
  "/life-insurance-calgary": "/fr/assurance-vie-calgary",
  "/life-insurance-mississauga": "/fr/assurance-vie-mississauga",
  "/life-insurance-winnipeg": "/fr/assurance-vie-winnipeg",
  "/life-insurance/ebook": "/fr/guide-assurance-vie",
  "/life-insurance/ebook/thank-you": "/fr/guide-assurance-vie/merci",
  "/term-life-insurance": "/fr/assurance-vie-temporaire",
  "/permanent-life-insurance": "/fr/assurance-vie-permanente",
  "/mortgage-insurance": "/fr/assurance-hypothecaire",
  "/whole-life-insurance": "/fr/assurance-vie-entiere",
  "/universal-life-insurance": "/fr/assurance-vie-universelle",
  "/participating-permanent-life-insurance": "/fr/assurance-vie-permanente-participante",
  "/no-medical-insurance": "/fr/assurance-sans-examen-medical",
  "/children-insurance": "/fr/assurance-enfants",
  "/health-insurance": "/fr/assurance-maladie",
  "/visitor-to-canada-insurance": "/fr/assurance-visiteurs-canada",
  "/super-visa-insurance": "/fr/assurance-super-visa",
  "/newcomers-insurance": "/fr/assurance-nouveaux-arrivants",
  "/international-student-insurance": "/fr/assurance-etudiants-internationaux",
  "/travel-insurance": "/fr/assurance-voyage",
  "/critical-illness-insurance": "/fr/assurance-maladies-graves",
  "/disability-insurance": "/fr/assurance-invalidite",
  "/first-home-savings-account": "/fr/compte-epargne-premier-logement",
  "/registered-education-savings-plan": "/fr/regime-epargne-etudes",
  "/tax-free-savings-account": "/fr/compte-epargne-libre-impot",
  "/registered-retirement-savings-plan": "/fr/regime-epargne-retraite",
  "/registered-disability-savings-plan": "/fr/regime-epargne-invalidite",
  "/einsured-rdsp-calculator": "/fr/calculateur-reei",
  "/faqs": "/fr/faq",
  "/reviews": "/fr/avis",
  "/case-studies": "/fr/etudes-de-cas",
  "/privacy-policy": "/fr/politique-confidentialite",
  "/terms-and-conditions": "/fr/conditions-utilisation",
  "/disclaimer": "/fr/avertissement",
  "/about-us": "/fr/a-propos",
  "/contact-us": "/fr/contactez-nous",
  "/our-team": "/fr/notre-equipe",
  "/our-team/aman": "/fr/notre-equipe/aman",
  "/our-team/sunaina": "/fr/notre-equipe/sunaina",
  "/our-team/shikha": "/fr/notre-equipe/shikha",
  "/our-team/gurkiran": "/fr/notre-equipe/gurkiran",
  "/our-team/yashraj": "/fr/notre-equipe/yashraj",
  "/our-team/ekta": "/fr/notre-equipe/ekta",
  "/our-team/samridhi": "/fr/notre-equipe/samridhi",
  "/our-team/aarti": "/fr/notre-equipe/aarti",
  "/quote/vtc": "/fr/devis/vtc",
  "/quote/vtc/quote-comparison-tool": "/fr/devis/vtc/comparaison",
  "/compare/vtc": "/fr/comparer/vtc",
  "/apply/vtc": "/fr/demande/vtc",
  "/apply/life": "/fr/demande/vie",
};

export const FR_TO_EN = Object.fromEntries(
  Object.entries(EN_TO_FR).map(([en, fr]) => [fr, en])
);

export function getAlternateUrl(pathname) {
  const isFrench = pathname === "/fr" || pathname.startsWith("/fr/");
  if (isFrench) {
    return FR_TO_EN[pathname] ?? "/";
  } else {
    // Blog is English-only, so it has no French alternate to switch to.
    return EN_TO_FR[pathname] ?? "/fr";
  }
}
